export class FormAjaxClass {
    private readonly DRY = false;
    constructor() {
    }

    formSubmit (form:HTMLFormElement, callback: any): void {
        let params = this.getFormParams(form)
        if (this.DRY) {
            setTimeout(() => callback(form, 'success'), 1500);
        } else {
            this.sendForm(form, params, callback)
        }
    }

    isActive (form: HTMLFormElement): boolean {
        return form.classList.contains('js-form-ajax');
    }

    private sendForm = function (form: HTMLFormElement, params: any, callback: any): void {
        const XHR = new XMLHttpRequest();
        XHR.open(form.method, form.action)
        XHR.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded')
        XHR.onload = function() {
            const response = JSON.parse(XHR.response);
            if (XHR.status === 200) {
                callback(form, response.success ? 'success' : 'post-error', response.msg)
            } else {
                callback(form, 'post-error', response.msg)
            }
        }
        XHR.send(params.join('&'));
    }

    private getFormParams (form: HTMLFormElement): string[] {
        const inputList: HTMLFormControlsCollection = form.elements
        const params = []

        for (let i = inputList.length - 1; i >= 0; i--) {
            const $input: any = inputList[i]
            if (FormAjaxClass.namelessInput($input) || FormAjaxClass.disabledInput($input) || FormAjaxClass.uncheckedInput($input)) {
                continue;
            }
            params.push(encodeURIComponent($input.name) + '=' + encodeURIComponent(this.getInputValue($input)))
        }

        return params
    }

    private getInputValue = function (input: any) {
        if (input.nodeName === 'SELECT') {
            return input.options[input.selectedIndex].value
        } else {
            return input.value
        }
    }

    private static namelessInput (input: HTMLInputElement) {
        return input.name === ''
    }

    private static disabledInput (input: HTMLInputElement) {
        return input.disabled === true
    }

    private static uncheckedInput (input: HTMLInputElement) {
        return (input.type === 'checkbox' || input.type === 'radio') && input.checked === false
    }
}
